import type { TransitionClasses, TransitionEvents } from '@headlessui/react';
import { Transition as TransitionHeadless } from '@headlessui/react';
import React from 'react';
import variables from '../../utils/variables';

// Use the Transition component
interface TransitionProps extends TransitionClasses, TransitionEvents {
    show?: boolean;
    appear?: boolean;
    as?: React.ElementType;
    className?: string;
    children: React.ReactNode;
}

export const Transition: React.FC<TransitionProps> = (props) => {
    if (!variables.TRANSITION) {
        // Adjust the props to disable transitions
        const newProps = {
            ...props,
            enter: '',
            enterFrom: '',
            enterTo: '',
            leave: '',
            leaveFrom: '',
            leaveTo: '',
            // You might need to adjust other props depending on how you want to disable transitions
        };
        return <TransitionHeadless {...newProps} />;
    }

    return <TransitionHeadless {...props} />;
};
